import themeColorsDesingSystem from "assets/theme/ds-colors";

export const CONTENT_TABS = [
  { key: "Todos", label: "Todos" },
  { key: "Campanhas", label: "Campanhas" },
  { key: "Banners", label: "Banners" },
  { key: "Lookbooks", label: "Lookbooks" },
  { key: "Videos", label: "Vídeos" },
  { key: "Materiais", label: "Materiais" },
];

export const CONTENT_TYPES = [
  { value: "Campanha", label: "Campanha" },
  { value: "Banner", label: "Banner" },
  { value: "Lookbook", label: "Lookbook" },
  { value: "Video", label: "Vídeo" },
  { value: "MaterialPdf", label: "Material PDF" },
  { value: "Institucional", label: "Institucional" },
  { value: "VmMerchandising", label: "VM / Merchandising" },
];

export const CONTENT_STATUS = [
  { value: "Rascunho", label: "Rascunho" },
  { value: "Publicado", label: "Publicado" },
  { value: "Agendado", label: "Agendado" },
  { value: "Expirado", label: "Expirado" },
  { value: "Arquivado", label: "Arquivado" },
  { value: "EmRevisao", label: "Em revisão" },
];

export const SORT_OPTIONS = [
  { value: "recentes", label: "Mais recentes" },
  { value: "atualizados", label: "Últimos atualizados" },
  { value: "acessados", label: "Mais acessados" },
];

export const MATERIAL_TYPES = [
  { value: "PDF", label: "PDF" },
  { value: "JPG", label: "JPG" },
  { value: "PNG", label: "PNG" },
  { value: "MP4", label: "MP4" },
  { value: "LINK", label: "Link externo" },
  { value: "ZIP", label: "ZIP" },
];

export const SEGMENTATION_OPTIONS = [
  { value: "Loja", label: "Loja" },
  { value: "Marca", label: "Marca" },
  { value: "Perfil", label: "Perfil" },
];

export const VIDEO_SOURCE_OPTIONS = [
  { value: "link", label: "Link externo" },
  { value: "upload", label: "Upload de arquivo" },
];

export const ACCEPT_IMAGES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
];

export const ACCEPT_VIDEOS = [
  "video/mp4",
  "video/quicktime",
  "video/x-msvideo",
  ".mp4",
  ".mov",
  ".avi",
];

export const ACCEPT_MATERIAL_FILES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
  "video/mp4",
  "application/zip",
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".mp4",
  ".zip",
];

export const ACCEPT_ICONS = [
  "image/svg+xml",
  "image/png",
  "image/jpeg",
  "image/webp",
  ".svg",
  ".png",
  ".jpg",
  ".webp",
];

const { primary, secondary, green, orange, yellow, red, gray, stone } =
  themeColorsDesingSystem;

export const TYPE_STYLE = {
  Campanha: { bg: `${primary.main}22`, color: primary.main },
  Banner: { bg: `${secondary.main}44`, color: primary.dark },
  Lookbook: { bg: `${secondary.main}33`, color: primary.main },
  Video: { bg: orange.background, color: orange.main },
  MaterialPdf: { bg: stone.light, color: gray.dark },
  Institucional: { bg: green.background, color: green.main },
  VmMerchandising: { bg: stone.main, color: gray.dark },
};

export const STATUS_STYLE = {
  Rascunho: { bg: stone.light, color: gray.dark },
  Publicado: { bg: green.backgroundActive, color: green.main },
  Agendado: { bg: yellow.background, color: "#9a7b00" },
  Expirado: { bg: red.background, color: red.main },
  Arquivado: { bg: stone.light, color: gray.dark },
  EmRevisao: { bg: `${secondary.main}44`, color: primary.main },
};

export function getTypeLabel(tipo) {
  return CONTENT_TYPES.find((t) => t.value === tipo)?.label || tipo;
}

export function getStatusLabel(status) {
  return CONTENT_STATUS.find((s) => s.value === status)?.label || status;
}

export function formatDate(dateStr) {
  if (!dateStr) return "-";
  const datePart = dateStr.includes("T") ? dateStr.split("T")[0] : dateStr;
  const [y, m, day] = datePart.split("-");
  return `${day}/${m}/${y}`;
}

export function matchesTab(tipo, tabKey) {
  if (tabKey === "Todos") return true;
  if (tabKey === "Campanhas") return tipo === "Campanha";
  if (tabKey === "Banners") return tipo === "Banner";
  if (tabKey === "Lookbooks") return tipo === "Lookbook";
  if (tabKey === "Videos") return tipo === "Video";
  if (tabKey === "Materiais") {
    return ["MaterialPdf", "Institucional", "VmMerchandising"].includes(tipo);
  }
  return true;
}
